/**
 * Turn a menu href into a comparable pathname:
 * drops the origin, collapses the /fa/v2 prefix to /fa and trims trailing slashes.
 */
export function normalizeMenuPath(href: string): string {
    if (!href) return ''

    try {
        const pathname = new URL(href, 'https://vahdatoptic.local').pathname
        return (pathname.replace(/^\/fa\/v2(?=\/|$)/, '/fa').replace(/\/+$/, '') || '/')
    } catch {
        return ''
    }
}
